import React from 'react';

import { Character, Interior, Label, StyledResurrection } from './styles';

export interface ResurrectionProps {
    label: string;
    compact?: boolean;
}

const NON_BREAKING_CHARACTER = '\u00A0';

export function Resurrection({ label, compact = false }: ResurrectionProps) {
    const characters = [...label].map((character, index) => {
        const formattedCharacter = character === ' ' ? NON_BREAKING_CHARACTER : character;

        return (
            <Character key={`Resurrection-Character-${formattedCharacter}-${index}`}>{formattedCharacter}</Character>
        );
    });

    return (
        <StyledResurrection $compact={compact}>
            <Interior>
                <Label>{characters}</Label>
            </Interior>
        </StyledResurrection>
    );
}
